module.exports = __webpack_public_path__ + "static/media/Street.087869a1.svg";